/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TokenAuthorization } from '../models/TokenAuthorization';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserLoginService {
    /**
     * Login with identity token and get authorization token
     * @returns TokenAuthorization OK
     * @throws ApiError
     */
    public static getAuthorization(): CancelablePromise<TokenAuthorization> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/login',
        });
    }
}
